import React, { useMemo, useState, useEffect} from 'react';
import { useTable, useGlobalFilter, usePagination } from 'react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'font-awesome/css/font-awesome.min.css';
import '../css/usermain.css';
import axios from 'axios';
import AddTaskPopup from './AddTaskPopup';
import { faSquare } from '@fortawesome/free-solid-svg-icons';
import AcademicGuruLogo from '../assets/academicguru.png';
import LeelagreenLogo from '../assets/leelagreen.jpg';
import AGPHLogo from '../assets/agph.png';
import IJISEMLogo from '../assets/ijisem.png';
import { useNavigate } from 'react-router-dom';
import ProjectSidebar from './ProjectSidebar';

const UserProjectTable = () => {
    const [filterInput, setFilterInput] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    const [projectData, setProjectData] = useState([]);
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [selectedProject, setSelectedProject] = useState(null);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [hoveredRowIndex, setHoveredRowIndex] = useState(null);
       
     
       const handleRowClick = (project) => {
         setSelectedProject(project);
         setSidebarOpen(true);
       };

  useEffect(() => {
    axios
      .get("/api/mainuser.php?action=dashboard", { withCredentials: true })
      .then((res) => setUser(res.data.user))
      .catch(() => (window.location.href = "/userlogin")); // redirect if not logged in
  }, []);
   
  

 const filteredProjects = useMemo(() => {
           const query = filterInput.toLowerCase().trim();
         
           // If search is active, include all tasks (even "done")
           if (query !== '') {
                    return projectData.filter(project =>
                      project.name.toLowerCase().includes(query) ||
                      project.assign_to.toLowerCase().includes(query) ||
                      project.assign_by?.toLowerCase().includes(query) ||
                      project.client?.toLowerCase().includes(query) ||
                      project.status?.toLowerCase().includes(query) ||
                      project.category?.toLowerCase().includes(query) ||
                      project.submission_date?.toLowerCase().includes(query) ||
                      project.company_name?.toLowerCase().includes(query) ||
                      project.project_id?.toLowerCase().includes(query)
                    );
                  }
         
           // If not searching, exclude "done" tasks
          return projectData.filter(project => project.status?.toLowerCase() !== 'done');
         }, [projectData, filterInput]);

       useEffect(() => {
    
         axios.get('/api/mainuser.php?action=projects', { withCredentials: true })
           .then(res => setProjectData(res.data))
           .catch(err => console.error('Fetch error:', err));
       }, []);
 
 
       const renderTaskStatusSquares = (taskCountJson) => {
         let parsed = {
           "Hold": 0,
           "To Do": 0,
           "Doing": 0,
           "Done": 0
         };
 
         try {
           if (typeof taskCountJson === 'string') {
             const temp = JSON.parse(taskCountJson);
             parsed = { ...parsed, ...temp };
           } else if (typeof taskCountJson === 'object' && taskCountJson !== null) {
             parsed = { ...parsed, ...taskCountJson };
           }
         } catch (e) {
           // silently fail
         }
 
         const colorMap = {
           'Hold': 'text-gray-300',
           'To Do': 'text-red-300',
           'Doing': 'text-yellow-300',
           'Done': 'text-green-300',
         };
 
         return (
           <div className="flex flex-wrap gap-0.5">
             {['Hold','To Do', 'Doing', 'Done'].map((key) =>
               parsed[key] > 0
                 ? [...Array(parsed[key])].map((_, idx) => (
                     <FontAwesomeIcon
                       key={`${key}-${idx}`}
                       icon={faSquare}
                       className={`text-[9px] ${colorMap[key]}`}
                     />
                   ))
                 : null
             )}
           </div>
         );
       };
 

 
       
 
     const projectColumns = useMemo(() => [
       {
         Header: "",
         accessor: "company_name",
         Cell: ({ value }) => {
           const companyLogoMap = {
             'IJISEM': IJISEMLogo,
             'Academic Guru': AcademicGuruLogo,
             'Leela Greens': LeelagreenLogo,
             'AGPH': AGPHLogo,
           };
           const logo = companyLogoMap[value];
           return logo ? (
             <img
               src={logo}
               alt={value}
               className="h-6 w-6 rounded-full"
               title={value}
             />
           ) : (
             <span>{value}</span>
           );
         }
       },
       {
         Header: "Project ID",
         accessor: "project_id",
         Cell: ({ row }) => (
           <button
             onClick={(e) => {
               e.stopPropagation(); // prevent triggering row navigation
               handleRowClick(row.original);
             }}
             className="text-blue-600  hover:text-blue-800"
           >
             {row.original.project_id}
           </button>
         )
       },
       { Header: "Name", accessor: "name" },
       { Header: "Client", accessor: "client" },
       { Header: "Category", accessor: "category" },
       { Header: "Manage By", accessor: "assign_to" },
       {
         Header: "Assignees",
         accessor: "team_members",
         Cell: ({ value }) => {
           if (!value) return null;
           const members = value
             .split(',')
             .map(m => m.trim())
             .filter(m => m.length > 0);
   
           return (
             <span
               className="inline-flex items-center justify-center w-6 h-6 rounded-full text-xs font-semibold text-gray-700 bg-gray-200"
               title={members.join(', ')} // tooltip on hover
             >
               {members.length}
             </span>
           );
         }
       },
       {
         Header: "Progress",
         accessor: "no_of_task",
         Cell: ({ value }) => renderTaskStatusSquares(value),
       },
       {
        Header: "Deadline",
        accessor: "submisssion_date",
        Cell: ({ value }) =>
          value
            ? new Date(value).toLocaleDateString('en-GB').replace(/\//g, '-')
            : 'No Date',
      },


     ], []);
 

 
 // Project Table
 const {
   getTableProps: getProjectTableProps,
   getTableBodyProps: getProjectTableBodyProps,
   headerGroups: projectHeaderGroups,
   prepareRow: prepareProjectRow,
   page: projectPage
 } = useTable(
   {
     columns: projectColumns,
     data: filteredProjects,
     initialState: { pageIndex: 0, pageSize: 20 }
   },
   useGlobalFilter,
   usePagination
 );
 

 
 
 
       return (
         <div className="container-dash  pt-5 px-6  h-190">
           <div className="d-flex justify-content-center ">
             <div className="search shadow-xl">
               <input
                 className="search_input"
                 type="text"
                 placeholder="Search here..."
                 value={filterInput}
                 onChange={e => {
                   setFilterInput(e.target.value);
                   
                 }}
               />
               <a href="#/" className="search_icon" onClick={e => e.preventDefault()}>
                 <i className="fa fa-search"></i>
               </a>
             </div>
           </div>
           <div className='flex text-right  mr-3 font-semibold text-gray-500 justify-between'>
              <div className="flex space-x-4 ">
                
              </div>
              <div className='mb-3'>
                <button
                  onClick={() => setShowPopup(true)}
                  className='bg-white p-4 pt-1 pb-1 rounded shadow-xl'
                >
                  <span className='text-red-400 text-lg'>+</span> Add 
                </button>
              </div>
            </div>
           
       
        
       
       <div className="overflow-x-auto bg-white rounded shadow w-full shadow-xl  max-h-150 scrollbar-hide">
 <table {...getProjectTableProps()} className="min-w-full divide-y divide-gray-200">
   <thead className="bg-gray-700 sticky top-0 z-0">
     {projectHeaderGroups.map(headerGroup => {
       const { key, ...restHeaderProps } = headerGroup.getHeaderGroupProps();
       return (
         <tr key={key} {...restHeaderProps}>
           {headerGroup.headers.map(column => {
             const { key, ...restColProps } = column.getHeaderProps();
             return (
               <th
                 key={key}
                 {...restColProps}
                 className="px-3 py-3 text-left text-xs font-medium text-white uppercase tracking-wider whitespace-nowrap"
               >
                 {column.render('Header')}
               </th>
             );
           })}
         </tr>
       );
     })}
   </thead>
 
   <tbody {...getProjectTableBodyProps()} className="divide-y divide-gray-200">
     {projectPage.map(row => {
       prepareProjectRow(row);
       const { key, ...restRowProps } = row.getRowProps();
       return (
         <tr key={key} {...restRowProps}  onClick={() => navigate(`/${row.original.project_id}?user=${user?.name}`)} className={`cursor-pointer ${hoveredRowIndex === row.id ? 'bg-gray-100' : ''}`}
  onMouseEnter={() => setHoveredRowIndex(row.id)}>
           {row.cells.map(cell => {
             const { key, ...restCellProps } = cell.getCellProps();
             return (
               <td
                 key={key}
                 {...restCellProps}
                 className="px-3 py-3 text-xs text-gray-700 "
               >
                 {cell.render('Cell')}
               </td>
             );
           })}
         </tr>
       );
     })}
   </tbody>
 </table>
 
   
    
       </div>
    {sidebarOpen && (
  <div className="fixed inset-0 z-40  backdrop-blur-sm transition-opacity duration-300">
    <ProjectSidebar
      isOpen={sidebarOpen}
      onClose={() => setSidebarOpen(false)}
      project={selectedProject}
    />
  </div>
)}
     
     {showPopup && <AddTaskPopup onClose={() => setShowPopup(false)} />}
 
      
         </div>
 
         
   );
 
   
}

export default UserProjectTable